import { IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Fragment } from 'react';


export default function AddImagens({ avaliacao, setAvaliacao, addImagens }) {

    async function HandleChangeFile(file) {
        if (!file) return;

        // Garante que file é convertido em array
        const arquivos = Array.from(file);

        setAvaliacao(prev => ({
            ...prev,
            imagens: [...(prev.imagens || []), ...arquivos]
        }));
    }

    // REMOVER IMAGENS SELECIONADAS
    function removerImagemPorIndice(indice) {
        setAvaliacao(prev => ({
            ...prev,
            imagens: prev.imagens.filter((_, i) => i !== indice)
        }));
    }

    return (
        <>
            {avaliacao?.imagens?.length > 0 &&
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    {avaliacao?.imagens.map((imagem, index) =>
                        <Fragment key={index}  >
                            {addImagens &&
                                <IconButton style={{ height: 10 }} onClick={() => removerImagemPorIndice(index)}> <CloseIcon color='error' /></IconButton>
                            }
                            <img src={addImagens ? URL.createObjectURL(imagem) : imagem} alt={index} width={'25%'} style={{ margin: 5 }} />
                        </Fragment>
                    )}
                </div>
            }

            {addImagens &&
                <div align="center" style={{ border: '1px dashed', borderRadius: 5, marginTop: 10 }}>
                    <label htmlFor="imagens" style={{ margin: 5, cursor: 'pointer' }} >
                        <Typography variant="subtitle2" >
                            Adicionar imagens (opcional)
                        </Typography>
                    </label>
                    <input multiple accept=" image/png, image/jpg, image/jpeg" type="file" name="imagens" id="imagens" style={{ display: 'none' }} onChange={(e) => HandleChangeFile(e.target.files)} />
                </div>
            }
        </>
    )
}
